import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getServiceCompletionRateSummary } from '@/service/dashboard';

const defaultState = {    
  fetching: false,
  error: null,
  query: {},
  data: {
    // catering: 0.6,
    // homeService: 0.7,
    // housekeeping: 0.89,
    // nursingCare: 0.5,
    // overallCompletion: 0.65,
    // postpartumCare: 0.75
  }
}

export const fetchServiceCompletionRateSummary = createAsyncThunk(
  'serviceCompletionRateSummary/fetchServiceCompletionRateSummary',
  async ({query = {}}, {rejectWithValue}) => {
    try {
      const response = await getServiceCompletionRateSummary(query);
      return {
        data: response.data,
        query
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || '获取日服务完成率汇总失败');
    }
  }
)

const serviceCompletionRateSummarySlice = createSlice({
  name: 'serviceCompletionRateSummary',
  initialState: defaultState,
  reducers: {
    resetServiceCompletionRateSummaryState: (state, action) => {
      state.query = {};
      state.data = {};
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchServiceCompletionRateSummary.pending, (state, action) => {
        state.fetching = true;
        state.error = null;
        state.query = action.meta.arg.query;
      })
      .addCase(fetchServiceCompletionRateSummary.fulfilled, (state, action) => {
        state.fetching = false;
        state.error = null;
        state.data = action.payload.data;
        state.query = action.payload.query;
      })
      .addCase(fetchServiceCompletionRateSummary.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.data = {};
      });
  }
})

export const { resetServiceCompletionRateSummaryState } = serviceCompletionRateSummarySlice.actions;
export default serviceCompletionRateSummarySlice.reducer;